import StoreService from '@/store/StoreService'
import { STORAGE_BUCKET_FOLDER_USER_IMAGES } from '@/utils/constants'

export function useUserImageStorageFolder({ path }: { path?: string } = {}) {
  const store = StoreService.getStore()
  return `${STORAGE_BUCKET_FOLDER_USER_IMAGES}/${store.user.userId}${path ? `/${path}` : ''}`
}
